const PREVIEW_TOKEN = 'bb-preview-x7k2m4p9'

export type CustomizationPreviewConfig = {
	isPreview: true
	previewSku: string
	previewType: 'NMC' | 'RMC'
}

export function parseCustomizationPreviewParams(query: {
	preview?: string | string[]
	sku?: string | string[]
	type?: string | string[]
}): CustomizationPreviewConfig | null {
	const token = Array.isArray(query.preview) ? query.preview[0] : query.preview
	const sku = Array.isArray(query.sku) ? query.sku[0] : query.sku
	const type = Array.isArray(query.type) ? query.type[0] : query.type

	if (token !== PREVIEW_TOKEN || !sku) return null

	return {
		isPreview: true,
		previewSku: sku,
		previewType: type === 'RMC' ? 'RMC' : 'NMC'
	}
}
